import { useState } from 'react';
import FAQAccordionItem from '@/components/FAQAccordionItem';

export default function LocaleFAQ({ title, faqs }) {
  const [open, setOpen] = useState(null);
  return (
    <section className="mb-16">
      <h2 className="font-inter font-black text-3xl md:text-4xl tracking-[-0.03em] text-foreground mb-6">{title}</h2>
      <div className="space-y-3">
        {faqs.map((f, i) => (
          <FAQAccordionItem
            key={f.question}
            question={f.question}
            answer={f.answer}
            isOpen={open === i}
            onToggle={() => setOpen(open === i ? null : i)}
          />
        ))}
      </div>
    </section>
  );
}